import { render, staticRenderFns } from "./Information.vue?vue&type=template&id=35171844&lang=pug"
import script from "./Information.vue?vue&type=script&lang=coffee"
export * from "./Information.vue?vue&type=script&lang=coffee"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports